<template>
  <footer id="footer">
    <div class="container">
      <div class="footer-shell banner-slab">
        <div class="footer-grid">
          <div class="footer-copy">
            <div class="section-kicker">7x24小时售后支持</div>
            <div class="section-title">重庆安宸佑科技为会员权益业务提供资源、系统与运营的一站式支持。</div>
            <div class="section-subtitle">
              全国7×24小时客服热线，多对一团队服务，帮助客户更快落地会员权益项目。
            </div>
            <div class="section-actions">
              <router-link to="/software" class="site-btn site-btn--primary">查看产品</router-link>
              <router-link to="/contactus" class="site-btn site-btn--ghost">联系咨询</router-link>
            </div>
          </div>

          <div class="footer-info-grid">
            <div class="soft-card footer-info-item">
              <div class="footer-label">7x24小时售后支持</div>
              <div class="footer-value">全国7×24小时客服热线</div>
            </div>
            <div class="soft-card footer-info-item">
              <div class="footer-label">性能安全</div>
              <div class="footer-value">30,000+ 每秒访问处理经验</div>
            </div>
            <div class="soft-card footer-info-item">
              <div class="footer-label">增值服务</div>
              <div class="footer-value">自助发卡系统，自主设计/渠道推广</div>
            </div>
            <div class="soft-card footer-info-item">
              <div class="footer-label">多对一团队服务</div>
              <div class="footer-value">商务运营团队多对一提供服务</div>
            </div>
          </div>
        </div>
      </div>

      <div class="footer-bottom">
        <div class="footer-brand">
          <span class="brand-mini"></span>
          <div>
            <strong>重庆安宸佑科技</strong>
            <p>会员权益解决方案供应商</p>
          </div>
        </div>
        <div class="footer-copyline">
          © 2026 重庆安宸佑科技.
          <a
            class="footer-copyline-link"
            href="https://beian.miit.gov.cn/"
            target="_blank"
            rel="noopener noreferrer"
          >渝ICP备2026010440号-1</a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer"
};
</script>

<style scoped>
#footer {
  padding: 30px 0 38px;
}

.footer-shell {
  padding: 34px;
  background:
    linear-gradient(135deg, rgba(16, 28, 42, 0.96), rgba(24, 42, 66, 0.94)),
    linear-gradient(135deg, rgba(47, 107, 219, 0.16), rgba(27, 154, 179, 0.1));
  border-color: rgba(255, 255, 255, 0.08);
}

.footer-shell::before {
  opacity: 0.18;
}

.footer-shell::after {
  inset: auto -10% -46% auto;
  width: 280px;
  height: 280px;
  background: radial-gradient(circle, rgba(97, 142, 255, 0.18) 0%, rgba(97, 142, 255, 0.05) 58%, transparent 72%);
}

.footer-grid {
  display: grid;
  grid-template-columns: 1.1fr 0.9fr;
  gap: 24px;
  align-items: stretch;
}

.footer-copy .section-kicker {
  background: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.88);
}

.footer-copy .section-kicker::before {
  background: #8fb7ff;
  box-shadow: 0 0 0 6px rgba(143, 183, 255, 0.16);
}

.footer-copy .section-title {
  max-width: 700px;
  color: #fff;
}

.footer-copy .section-subtitle {
  max-width: 650px;
  color: rgba(255, 255, 255, 0.74);
}

.footer-copy .site-btn--ghost {
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
  border-color: rgba(255, 255, 255, 0.12);
}

.footer-info-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}

.footer-info-item {
  min-height: 122px;
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.1);
}

.footer-label {
  color: rgba(255, 255, 255, 0.66);
  font-size: 13px;
}

.footer-value {
  margin-top: 12px;
  color: #fff;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.5;
}

.footer-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 18px 6px 0;
  color: var(--muted);
}

.footer-brand {
  display: flex;
  align-items: center;
  gap: 12px;
}

.brand-mini {
  position: relative;
  width: 34px;
  height: 34px;
  border-radius: 12px;
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.04)),
    linear-gradient(180deg, rgba(255, 255, 255, 0.96), rgba(236, 243, 251, 0.96));
  border: 1px solid rgba(255, 255, 255, 0.12);
  box-shadow: 0 10px 26px rgba(47, 107, 219, 0.2);
  overflow: hidden;
}

.brand-mini::before,
.brand-mini::after {
  content: "";
  position: absolute;
  display: block;
}

.brand-mini::after {
  right: 6px;
  top: 6px;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #1b9ab3;
  box-shadow: 0 0 0 4px rgba(27, 154, 179, 0.12);
}

.brand-mini::before {
  inset: 7px 9px 7px 8px;
  border-radius: 10px;
  background: linear-gradient(135deg, #2f6bdb 0%, #5b86f5 55%, #1b9ab3 100%);
  transform: skewX(-18deg);
}

.footer-brand strong {
  color: var(--text);
  font-size: 15px;
}

.footer-brand p {
  margin-top: 4px;
  font-size: 12px;
}

.footer-copyline {
  text-align: right;
  font-size: 13px;
  line-height: 1.6;
}

.footer-copyline-link {
  color: inherit;
  text-decoration: none;
}

.footer-copyline-link:hover {
  text-decoration: underline;
}

@media screen and (max-width: 991px) {
  .footer-shell {
    padding: 24px;
  }

  .footer-grid {
    grid-template-columns: 1fr;
  }
}

@media screen and (max-width: 767px) {
  #footer {
    padding-bottom: 24px;
  }

  .footer-info-grid {
    grid-template-columns: 1fr;
  }

  .footer-bottom {
    flex-direction: column;
    align-items: flex-start;
  }

  .footer-copyline {
    text-align: left;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue